import axios from 'axios';

export const deleteAnnouncement = async (announcementId: string) => {
  await axios.post(`/announcement/${announcementId}`);
};
